import { Typography } from "@mui/material";

import { RowBase, RowChoiceProps } from "./RowBase";

export function RowText({ answer }: RowChoiceProps) {
    return (
        <RowBase question={answer.question}>
            <pre
                style={{
                    whiteSpace: "pre-line",
                    wordWrap: "break-word",
                    margin: 0,
                }}
            >
                <Typography>{answer.answer ?? "-"}</Typography>
            </pre>
        </RowBase>
    );
}
